export const CONTACT = {
  email: "contact@painternational.in",
  emailAlt: "pa_international@yahoo.com",
  phone: "+91 98351 36191",
  phoneHref: "+919835136191",
  hours: "Monday – Saturday · 9:30 AM – 6:30 PM IST",
  bhagalpur: {
    label: "Manufacturing Headquarters",
    lines: ["P.A. International", "22, Anand Chikitsalaya Road", "Gulab Ram Lane", "Bhagalpur, Bihar 812002, India"],
    mapEmbed:
      "https://www.openstreetmap.org/export/embed.html?bbox=86.9742,25.2365,86.9942,25.2485&layer=mapnik&marker=25.2425,86.9842",
    mapLink:
      "https://www.google.com/maps/search/?api=1&query=22%2C%20Anand%20Chikitsalaya%20Road%2C%20Gulab%20Ram%20Lane%2C%20Bhagalpur%2C%20Bihar%20812002",
  },
  kolkata: {
    label: "Export & Logistics Office",
    lines: ["P.A. International", "4B, Circus Plaza", "4 Circus Avenue", "Kolkata, West Bengal 700017, India"],
    mapEmbed:
      "https://www.openstreetmap.org/export/embed.html?bbox=88.3565,22.5365,88.3765,22.5485&layer=mapnik&marker=22.5425,88.3665",
    mapLink:
      "https://www.google.com/maps/search/?api=1&query=4B%2C%20Circus%20Plaza%2C%204%20Circus%20Avenue%2C%20Kolkata%2C%20West%20Bengal%20700017",
  },
};

export const FABRICS = [
  {
    id: "pure-silk",
    name: "Pure Silk",
    tagline: "Lustrous mulberry silk with a fluid, liquid drape for eveningwear and couture.",
    composition: "100% cultivated mulberry silk",
    weight: "40 – 120 GSM",
    weave: "Plain, twill & satin",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-pure-silk-user.jpeg",
  },
  {
    id: "raw-silk",
    name: "Raw Silk",
    tagline: "Bhagalpur's signature wild silk — organic slub structure with a dry, honest hand.",
    composition: "100% wild tussar raw silk",
    weight: "80 – 180 GSM",
    weave: "Traditional pit-loom weave",
    loom: ["Handloom"],
    image: "/images/fabric-raw-silk.jpeg",
  },
  {
    id: "matka",
    name: "Matka Silk",
    tagline: "Hand-spun heavy silk yarn with a distinctive tweed-like texture and depth.",
    composition: "100% hand-spun silk",
    weight: "140 – 260 GSM",
    weave: "Dense box weave",
    loom: ["Handloom"],
    image: "/images/fabric-matka-user.jpeg",
  },
  {
    id: "dupion",
    name: "Dupion Silk",
    tagline: "Crisp, slubbed weave with a dual-tone shimmer — structured and luminous.",
    composition: "100% dupion silk yarn",
    weight: "100 – 200 GSM",
    weave: "Irregular slub warp & weft",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-dupion-user.jpeg",
  },
  {
    id: "linen",
    name: "Linen",
    tagline: "Natural Linen Flax - breathable, textural, quietly luxurious.",
    composition: "100% linen or linen–silk blends",
    weight: "110 – 240 GSM",
    weave: "Open slub & herringbone",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-linen-user.jpeg",
  },
  {
    id: "silk-cotton",
    name: "Silk Cotton",
    tagline: "The natural breathability of cotton balanced with silk's soft lustre — light, refined and versatile.",
    composition: "Silk–cotton blends",
    weight: "80 – 180 GSM",
    weave: "Plain, dobby & textured weaves",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-silk-cotton.jpeg",
  },
  {
    id: "viscose",
    name: "Viscose",
    tagline: "Silky sheen with enhanced durability — from fluid satins to plush bouclé textures.",
    composition: "Viscose & viscose–silk blends",
    weight: "120 – 220 GSM",
    weave: "Satin, dobby & bouclé",
    loom: ["Power loom", "Handloom"],
    image: "/images/fabric-viscose.png",
  },
  {
    id: "raffia",
    name: "Raffia",
    tagline: "Textured palm-fibre weaves for avant-garde home décor and accessories.",
    composition: "Natural raffia on cotton warp",
    weight: "200 – 450 GSM",
    weave: "Coarse artisan mesh",
    loom: ["Handloom"],
    image: "/images/fabric-raffia-user.jpeg",
  },
  {
    id: "sheer-silk",
    name: "Sheer Silk",
    tagline: "An airy, see-through silk with a delicate hand and fluid drape for layered couture and occasion wear.",
    composition: "Approx. 100% silk",
    weight: "Approx. 30 – 55 GSM",
    weave: "Plain / chiffon weave",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-sheer-silk.jpeg",
  },
  {
    id: "space-dyed-tweed",
    name: "Space-Dyed Tweed",
    tagline: "A rich, multicolour tweed with space-dyed yarn interest and a substantial textured surface.",
    composition: "Approx. silk, viscose & cotton blend",
    weight: "Approx. 220 – 320 GSM",
    weave: "Space-dyed textured tweed",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-space-dyed-tweed.jpeg",
  },
  {
    id: "tweed",
    name: "Tweed",
    tagline: "A dimensional tweed with woven checks and subtle sequin detail for statement fashion and interiors.",
    composition: "Approx. cotton, viscose & metallic yarn",
    weight: "Approx. 240 – 360 GSM",
    weave: "Checked bouclé tweed",
    loom: ["Handloom", "Power loom"],
    image: "/images/fabric-tweed.jpeg",
  },
  {
    id: "jet-black-sequin",
    name: "Jet Black Sequin",
    tagline: "A deep black textured ground with all-over sequin shimmer for dramatic evening and occasion applications.",
    composition: "Approx. polyester–viscose with sequins",
    weight: "Approx. 180 – 260 GSM",
    weave: "Sequin-embellished plain weave",
    loom: ["Power loom"],
    image: "/images/fabric-jet-black-sequin.jpeg",
  },
  {
    id: "recycled",
    name: "Recycled Yarn",
    tagline: "Loom offcuts and leftover yarn respun into new cloth — texture with a lighter footprint.",
    composition: "Recycled silk, cotton & viscose yarn",
    weight: "650 – 850 GSM",
    weave: "Heathered plain & basket weave",
    loom: ["Handloom", "Power loom"],
    note: "Spun from our own mill waste since 2015 — offcuts and leftover yarn are sorted by shade, respun and rewoven instead of discarded. Lot-to-lot shade variation is part of its character; we hold approved shade bands for repeat orders and can share full traceability of the waste stream on request.",
    image: "/images/fabric-recycled-user.jpeg",
  },
];

export const TIMELINE = [
  {
    year: "1991",
    title: "The first looms",
    text: "P.A. International is founded in Bhagalpur — the Silk City of India — weaving pure silk yardage on pit looms for domestic traders.",
  },
  {
    year: "1992",
    title: "First export consignment",
    text: "Our first international order ships: pure silk fabric to a USA fashion house. Exports become the heart of the business.",
  },
  {
    year: "1993",
    title: "Kolkata office opens",
    text: "A dedicated logistics and documentation office in Kolkata streamlines customs, freight and buyer communication.",
  },
  {
    year: "1996",
    title: "Dyeing brought in-house",
    text: "Fabric dyeing with eco-conscious dye practices gives buyers tighter colour control and faster lab dips.",
  },
  {
    year: "1999",
    title: "Finishing & inspection",
    text: "Dedicated mending, clipping and finishing lines, with 100% fabric inspection under the 4-point system before despatch.",
  },
  {
    year: "2002",
    title: "Power loom production begins",
    text: "Growing demand leads us to introduce power loom fabric production alongside our handlooms.",
  },
  {
    year: "2015",
    title: "Sustainability",
    text: "Offcuts and leftover yarn from our looms are recycled back into fabric production instead of going to waste.",
  },
  {
    year: "2026",
    title: "18+ markets and counting",
    text: "Today the second and third generations supply fashion and home décor buyers across the USA, Europe, UK, Gulf, China, Japan and Australia.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Development",
    text: "Composition, GSM, width and weave engineered to your spec — lab dips and strike-offs shared for approval.",
  },
  {
    step: "02",
    title: "Pre-bulk sample",
    text: "A handloom sample from actual production yarn is couriered for sign-off before a single metre of bulk is woven.",
  },
  {
    step: "03",
    title: "Production",
    text: "Bulk weaving on our looms with in-house dyeing, mending, clipping and finishing under one roof.",
  },
  {
    step: "04",
    title: "Quality check",
    text: "Every metre inspected under the 4-point system. Lot-wise inspection reports shared before packing.",
  },
  {
    step: "05",
    title: "Despatch",
    text: "Export packing, documentation and freight coordinated by our Kolkata office — FOB Kolkata/Haldia or air.",
  },
];

export const SERVICES = ["Yarn Dyeing", "Fabric Dyeing", "Mending", "Clipping Works", "Finishing"];

export const QUALITY_POINTS = [
  {
    title: "4-point inspection, every lot",
    text: "100% of fabric is inspected on the frame under the international 4-point system before despatch — never on a sampling basis.",
  },
  {
    title: "Approvals before bulk",
    text: "Lab dips, strike-offs and pre-bulk samples are approved by you first. Bulk never begins without written sign-off.",
  },
  {
    title: "Responsible dyeing",
    text: "Azo-free dyeing is available on request, with dye-lot records maintained for traceability.",
  },
  {
    title: "Third-party inspection welcomed",
    text: "SGS, Intertek or any buyer-nominated agency is welcome at our mill before shipment — we arrange access.",
  },
];

export const SOCIALS = [
  {
    id: "instagram",
    label: "Instagram",
    handle: "@p.a.international",
    url: "https://www.instagram.com/p.a.international/",
  },
  {
    id: "facebook",
    label: "Facebook",
    handle: "/painternational1991",
    url: "https://www.facebook.com/painternational1991",
  },
  { id: "x", label: "X", handle: "@PAIntl", url: "https://x.com/PAIntl" },
  {
    id: "whatsapp",
    label: "WhatsApp",
    handle: "+91 98351 36191",
    url: "https://wa.me/919835136191",
  },
];

export const GALLERY = [
  { src: "/images/gallery-handloom-work.jpeg", caption: "Handloom work, Bhagalpur" },
  { src: "/images/gallery-dye.png", caption: "Yarn dyeing — royal & gold lots" },
  { src: "/images/gallery-hand-rolling.jpeg", caption: "In-house hand rolling" },
  { src: "/images/gallery-power-loom-hall.jpeg", caption: "Power loom hall, daylight shift" },
  { src: "/images/gallery-export-packing.jpeg", caption: "Export packing, Kolkata despatch" },
  { src: "/images/gallery-clipping-mending.jpeg", caption: "Clipping & mending work, Bhagalpur mill" },
  { src: "/images/gallery-color-matching.jpeg", caption: "Colour matching for bulk" },
  { src: "/images/gallery-sampling-preparation.jpeg", caption: "Sampling preparation" },
  { src: "/images/gallery-fabric-bleaching.jpeg", caption: "Fabric processing for bleaching" },
  { src: "/images/gallery-fabric-calendering.jpeg", caption: "Fabric calendering" },
];

export const MARKETS = [
  { region: "Europe", detail: "Germany · France · Italy · Spain · Netherlands · Scandinavia" },
  { region: "United Kingdom", detail: "Fashion & interiors studios, London and beyond" },
  { region: "United States", detail: "Home décor converters and apparel labels" },
  { region: "Australia", detail: "Boutique fashion and textile importers" },
  { region: "Japan", detail: "Craft-led fashion houses and fabric converters" },
  { region: "UAE & GCC", detail: "Dubai-based buying offices serving the Gulf" },
];
